import React, {useMemo, useState} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {keys, map, filter, includes, flatMap, orderBy } from "lodash";
import MappingTableRow from "components/admin/elements/MappingTableRow";

function MappingTableSection(props) {
    const [emptyRows, setEmptyRows] = useState([])

    const mappings = useMemo(() => {
        return props.mappings
    }, [props.mappings]);

    const mappingIds = flatMap(mappings, "clinicProductId");

    const handleAddBlankMapping = () => {
        const order = 99999 + emptyRows.length + 1;
        setEmptyRows([
            ...emptyRows,
            {
                order,
                index: !!emptyRows?.length ? (emptyRows.length + 1) : 1,
                clinicProductId: null,
            }
        ])
    }

    const handleCreateMapping = (index, clinicProductId) => {
        const newEmptyRows = map(emptyRows, e => {
            if(index === e.index) {
                return {
                    ...e,
                    clinicProductId: clinicProductId
                }
            } else {
                return e;
            }

        })
        setEmptyRows(newEmptyRows);
    }

    const handleDeleteMapping = (clinicProductId) => {
        const newEmptyRows = filter(emptyRows, {clinicProductId: clinicProductId});
        setEmptyRows(newEmptyRows);
    }

    const row = (clinicProductId, showProduct, index=null) => {
        return(
            <MappingTableRow
                key={`${props.productId}-${clinicProductId}-${index}`}
                clinicId={props.clinicId}
                isFood={props.isFood}
                showProduct={showProduct}
                productId={props.productId}
                clinicProductId={clinicProductId}
                type={props.type}
                typeId={props.typeId}
                pimsOptions={props.pimsOptions}
                disabledPimsOptions={props.disabledPimsOptions}
                boldPimsOptions={props.boldPimsOptions}
                handleAddBlankMapping={handleAddBlankMapping}
                handleOnCreate={handleCreateMapping}
                handleOnDelete={handleDeleteMapping}
                index={index}
            />
        );
    }

    let firstRow = true;

    const filteredEmptyRows = filter(emptyRows, e => {
        return !includes(mappingIds, e.clinicProductId);
    })

    return (
        <>
            {/*Rows with mappings*/}
            {!!keys(mappings).length ? (
                map(orderBy(mappings, "order"), (mapping) => {
                    const showProduct = firstRow;
                    firstRow = false;
                    return (row(mapping.clinicProductId, showProduct))
                })
            ) : (
                //Section with no mappings
                row(null, true)
            )}

            {/*Additional Empty Rows*/}
            {map(filteredEmptyRows, e => row(null, false, e.index))}
        </>
    )

}

MappingTableSection.propTypes = {
    pimsOptions: PropTypes.array.isRequired,
    disabledPimsOptions: PropTypes.array.isRequired,
    boldPimsOptions: PropTypes.array.isRequired,
    clinicId: PropTypes.number.isRequired,
    productId: PropTypes.number.isRequired,
    typeId: PropTypes.string.isRequired,
    type: PropTypes.string,
    isFood: PropTypes.bool,
};

export default connect(
    (state, ownProps) => {
        const mappings = (ownProps.isFood ? state.entities.foodMappings?.[ownProps.clinicId] : state.entities.pharmacyMappings?.[ownProps.clinicId]) || {};
        return {
            mappings: mappings?.[ownProps.productId]?.mappings || {},
        }
    },
) (MappingTableSection);
